export const getTripsDetails = (placeTrips: any, allTrips: any) => {
  return placeTrips
    .map((placeTrip: any) => allTrips[placeTrip])
    .filter((trip: any) => trip.hidden !== true && !trip.isFutureTrip)
    .sort((a: any, b: any) => (a.name < b.name ? -1 : 1));
};
